import { CustomFieldsCard, usePatientCustomValues, useSavePatientCustomValues } from "../../../center";

/** The centre's own fields for one of the professional's patients, read and edited in place. */
export default function PatientCustomFields({ patientId }: { patientId: string }) {
    const values = usePatientCustomValues(patientId);
    const save = useSavePatientCustomValues(patientId);

    return (
        <CustomFieldsCard
            data={values.data}
            isLoading={values.loading}
            isError={values.failed}
            onRetry={values.retry}
            onSave={(changes) => save.mutateAsync(changes)}
            isSaving={save.isPending}
        />
    );
}
